import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
  FaPlus,
  FaMinus,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import { Container, ContainerWhite, Line, Image } from './styles';
import Input from '../../components/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';

import { Pattern } from '../../styles/ThemeComponents';
import ShowDiv from '../../components/ShowOnScroll';
import VideoBackground from '../../components/VideoBackground';
import TextPopper from '../../components/TextPopper';
import Scroller from '../../components/Scroller';

import Vimeo from '../../components/Vimeo';
import Youtube from '../../components/Youtube';
import ContagemRegressiva from '../../components/ContagemRegressiva';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Sobre: React.FC = () => {
  const [active, setActive] = useState(false);
  return (
    <>
      <ContainerWhite id="programacao">
        <div
          style={{
            width: '100%',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <h2
            className="titleLine"
            style={{
              justifyContent: 'center',
              display: 'inline-block',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {' '}
            PROGRAMAÇÃO
          </h2>

          <div
            className="separator"
            style={{ width: '80%', maxWidth: '100%', margin: '30px auto' }}
          />
        </div>
        <div className="p50 p600" style={{ overflowX: 'hidden' }}>
          <br />
          <div>
            <h2 className="titleLine"> Você é estudante do ensino médio?</h2>

            <div className="p50 p600">
              <p>
                Então não fique de fora,
{' '}
<br />
                participe e desperte suas competências empreendedoras
                <br />
                para encarar os desafios do futuro.
              </p>
            </div>
            <br />

            <Line position="left">
              <div>
                {' '}
                <Image background="/assets/evento/palestrantes/polly2.png" />
              </div>
              <h2>
                A partir das 18h,
{' '}
<strong>Formiga e Polly</strong> irão bater um
                papo e conduzir a programação.
              </h2>
            </Line>

            <Line position="left">
              <div>
                {' '}
                <Image background="/assets/evento/palestrantes/mauricio2.png" />
              </div>

              <h2>
                <strong>Maurício Benvenutti</strong>
{' '}
- Vai rolar um papo sobre
                tecnologia, profissões do futuro e inovação.
</h2>
            </Line>

            <Line position="right">
              <h2>
                <strong>Caio Carneiro</strong>
{' '}
- Traz comportamentos e atitudes
                para resultados incríveis.
</h2>
              <div>
                {' '}
                <Image background="/assets/evento/palestrantes/caio2.png" />
              </div>
            </Line>

            <Line position="left">
              <div>
                {' '}
                <Image background="/assets/evento/palestrantes/ze_felipe2.png" />
              </div>

              <h2>
                <strong>Zé Felipe</strong>
{' '}
- Vai contar a sua trajetória e a
                conexão com o empreendedorismo.
</h2>
            </Line>

            <Line position="right">
              <h2>
                <strong>Alice Salazar</strong>
{' '}
- Conta sobre o seu
                empreendedorismo na internet.
</h2>
              <div>
                <Image background="/assets/evento/palestrantes/alice2.png" />
              </div>
            </Line>
          </div>
        </div>
      </ContainerWhite>
    </>
  );
};
export default Sobre;
